import { TeamModel } from '@/types/teams';

// チームページの初期設定が完了しているかどうか
export const isTeamConfigInitialized = (team: TeamModel) => {
  return team.name !== 'Unnamed FC' && team.color_a !== '#9ca3af';
};
